// Set global header config values
const headerConfig = {
    transparentHeader: false,
    mobileMenuSlideTime: 200,
    desktopBreakPoint: 991,
    mobileMenuSlideTime: 200,
}
let navImagesLoaded = false;


if ($('body').hasClass('transparent-header')) { // For pages with transparent header
    headerConfig.transparentHeader = true;
}
  
// Hamburger menu open/close (mobile only)
$('#menu-btn').off().click( function(e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $('#primary-nav').toggleClass('active'); // Add active class
    $('form#mobile-search, nav#primary-nav-container, nav#mobile-secondary-nav').removeClass('slide-out'); // Close currency menu
    $('nav#primary-nav-container > ul > li.primary-nav-item').removeClass('active');
    $('.secondary-nav-items').slideUp(headerConfig.mobileMenuSlideTime); // Close secondary-nav-items
    // Header state
    if (headerConfig.transparentHeader == true && !$('header').hasClass('scrolled')) { // If is transparent header and at top
        $('body').toggleClass('transparent-header');
    }
    if ($('#primary-nav').hasClass('active')) {
      handleFixedElements('hide');
    } else {
      handleFixedElements('show');
    }
    // Manually lazy load nav images on first open
    if(navImagesLoaded == false) {
      let nav = document.getElementById('primary-nav-container');
      let navImages = nav.querySelectorAll('img[data-src-manual]');
      navImages.forEach((image) => image.setAttribute('src', image.getAttribute('data-src-manual')));
      navImagesLoaded = true;
    }
    if(document.getElementById('product-overview-overlay')) {
      if ($('#primary-nav').hasClass('active')) {
        document.getElementById('product-overview-overlay').classList.add('loading'); // If product overview video, hide on menu open
      } else {
        document.getElementById('product-overview-overlay').classList.remove('loading'); // If product overview video, show on menu close
      }
    }
});
  

// Mobile search open
$('#mobile-search-btn').on().click(function(e) {
    e.preventDefault();
    $('#menu-btn').addClass('active');
    $('#primary-nav').addClass('active');
    $('#primary-nav > ul, #mobile-search').removeClass('slide-out'); // Close currency menu
    if (headerConfig.transparentHeader == true) { // If transparent header, make solid
        $('body').removeClass('transparent-header');
    }
    handleFixedElements('hide');
    setTimeout( function() {
        $('#mobile-search').children('input[type="search"]').trigger('touchstart'); // trigger touchstart
        $('#mobile-search').children('input[type="search"]').on('touchstart', function() {
            $(this).focus();
        });
    }, headerConfig.mobileMenuSlideTime);
});


// iOS treatment of above
$('#mobile-search-btn').on('touchstart', function() {
    setTimeout( function() {
        $('#search-input-field-mobile').focus();
    }, headerConfig.mobileMenuSlideTime);
});


// Top level menu items open/close (mobile only)
$('#primary-nav > #primary-nav-container > ul > li.primary-nav-item > a').off().click(function(e) {
  if ($(this).find('.secondary-nav-items').length) {
    e.preventDefault();
  }
  if( window.innerWidth <= headerConfig.desktopBreakPoint ) { // Mobile only
      // Close all other menus
      $(this).parent().siblings().removeClass('active').find('.secondary-nav-items').slideUp(headerConfig.mobileMenuSlideTime);
      // Open clicked menu
      $(this).parent().find('.secondary-nav-items').slideToggle(headerConfig.mobileMenuSlideTime);
      $(this).parent().toggleClass('active'); // Always apply class with transitions after slide()
  }
});




// Mobile currency open
$('#primary-nav').on('click', '.currency-btn', function() {
    $('#primary-nav nav, #primary-nav #mobile-search').toggleClass('slide-out');
  });
  // Mobile currency close
  $('#primary-nav').on('click', '.currency-close-btn', function() {
    $('#primary-nav nav, #primary-nav #mobile-search').toggleClass('slide-out');
});
  


  
  // Clear search results (mobile)
  $('#search-input-field-mobile').keyup(function(){ // Check input on every keyup
    var mobileSearchInput = $(this);
    if (mobileSearchInput.val() === '') { // if blank
      mobileSearchInput.siblings('.clear').removeClass('active');
    } else {
      mobileSearchInput.siblings('.clear').addClass('active');
    }
  });
  $('#mobile-search .clear').off().click(function(e) { // Click clear button
    $('#search-input-field-mobile').val('').focus();
    $(this).removeClass('active');
  });
  
  

  // Change header state on scroll
  function headerScroll() {
    var scrolled = $(window).scrollTop();

    if( window.innerWidth > headerConfig.desktopBreakPoint ) { // Desktop 

      if( scrolled > transparentHeaderScrollTrigger ) { // If past top and menu open
        if (!$('#primary-nav').hasClass('dropdown-active')) {
            $('header').addClass('scrolled');
            $('body').removeClass('transparent-header');
        } 
      }
      else if (!$('#primary-nav').hasClass('dropdown-active')) { // If at top and menu open
        $('header').removeClass('scrolled');
        $('body').addClass('transparent-header');
      }
      else {
        $('header').removeClass('scrolled'); // If at top and menu closed
      }

    } else {

      if( scrolled > transparentHeaderScrollTrigger ) { // If past top and menu open
        if (!$('#primary-nav').hasClass('active')) {
            $('header').addClass('scrolled');
            $('body').removeClass('transparent-header');
        } 
      }
      else if (!$('#primary-nav').hasClass('active')) { // If at top and menu open
        $('header').removeClass('scrolled');
        $('body').addClass('transparent-header');
      }
      else {
        $('header').removeClass('scrolled'); // If at top and menu closed
      }

    }
  }
  if (transparentHeader == true) { // If page has transparent header
    headerScroll();
      $(window).scroll ( function() {	headerScroll(); });
      $(window).resize ( function() {	headerScroll(); });
  }
  
  
  
  // Hover on top level menu items (desktop only)
  $('#primary-nav > nav#primary-nav-container > ul > li').hover(function(e) {
    if( window.innerWidth > headerConfig.desktopBreakPoint ) { // Desktop only
      var thisTopLevelItem = $(this);
      thisTopLevelItem.addClass('active');

      if ($(this).find('.secondary-nav-items').length) {
        let activeMegaMenuHeight = $(this).find('.secondary-nav-items').outerHeight();
        $('#mega-menu-bg').addClass('active').css('height', activeMegaMenuHeight);
      }
      
      // Manually lazy load nav images on first hover
      if(navImagesLoaded == false) {
        let navImages = thisTopLevelItem.find('img[data-src-manual]');
        navImages.each(function(i){ $(this).attr('src', $(this).attr('data-src-manual')) });
        thisTopLevelItem.siblings().each(function() {
          thisTopLevelItem = $(this);
          navImages = thisTopLevelItem.find('img[data-src-manual]');
          navImages.each(function(i){ $(this).attr('src', $(this).attr('data-src-manual')) });
        });
        navImagesLoaded = true;
      }
      var innerLink = $(this).find('a.primary-nav-item-title');
      // Make header solid (applies to transparent header only)
      $('body').removeClass('transparent-header');
      if(!innerLink.hasClass('clickable')) {
        $('#primary-nav').addClass('dropdown-active');
      }
    }
  },function(e) {
    if( window.innerWidth > headerConfig.desktopBreakPoint ) { // Desktop only
      $(this).removeClass('active');
      $('#mega-menu-bg').removeClass('active');
      // Make header transparent (applies to transparent header only)
      if (headerConfig.transparentHeader == true && !$('header').hasClass('scrolled')) {
        $('body').addClass('transparent-header');
      }
      // Hide menu underline
      $('#primary-nav').removeClass('dropdown-active');
    }
  });